import styled from "styled-components";
export const LinkTab = styled.button `
  background-clip: padding-box;
  background-color: ${({ theme, isActive }) => isActive
    ? `rgba(${theme.colors.transparentBlack}, 0.12);`
    : `rgba(${theme.colors.transparentBlack}, 0);`};
  border: 1px solid
    ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0);`};
  color: ${({ theme }) => theme.colors.grey13};
  font-size: ${({ theme }) => theme.fontTokens.font13[0]};
  line-height: ${({ theme }) => theme.fontTokens.font13[1]};
  height: 2.5rem;

  &:hover {
    border: 1px solid
      ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.08);`};
    background-color: ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.08);`};
  }

  &:focus {
    ${({ focused, theme }) => focused ? `border: 1px solid ${theme.colors.primaryLight};` : ""};

    ${({ theme, focused }) => focused
    ? `outline: 1px solid ${theme.colors.primaryLight};`
    : "outline: none;"};
  }

  &:active {
    border: 1px solid ${({ theme }) => theme.colors.grey15};
    background-color: ${({ theme }) => theme.colors.grey15};
    color: ${({ theme }) => theme.colors.white};
  }

  &:disabled {
    cursor: default;
    border: 1px solid
      ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0);`};
    background-color: ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0);`};
    color: ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.3);`};
  }
`;
export const LinksWrapper = styled.div `
  & > button {
    cursor: pointer;
    margin-left: 1rem;

    &:first-child {
      max-height: 2.5rem;
      ${({ alignByContent }) => (alignByContent ? "margin-left: 0;" : "")}
    }

    ${({ alignByContent }) => alignByContent === "left"
    ? "transform: translateX(calc(-0.25rem - 1px));"
    : ""}
  }
`;
